exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desglose[data-v-8dad2bb0] {\n  display: inline-block;\n}\n.desglose .btn > .fa[data-v-8dad2bb0] {\n  font-size: 15px;\n  line-height: 20px;\n}", ""]);

// exports
